import { fetchData } from '../../_lib/lib';

export const executeVerticalSyncV3 = async (
  syncFor: string,
  environment: string,
  release: string,
  type?: string,
  tenantId?: string
) => {
  const bodyPayload: any = { environment, release };
  if (type) {
    bodyPayload.type = type;
    bodyPayload.tenantId = tenantId;
  }
  return await fetchData(
    'PATCH',
    `schema-sync${syncFor !== 'master' ? '-slave' : ''}/vertical-sync-v3`,
    { body: bodyPayload }
  );
};

export const fetchSchemaReviewV3 = async (
  environment: string,
  release: string,
  type?: string
) => {
  const bodyPayload: any = { environment, release };
  if (type) bodyPayload.type = type;
  return await fetchData('PATCH', 'schema-sync/schema-review-before-sync-v3', {
    body: bodyPayload,
  });
};

export const fetchSchemaApprovalV3 = async (
  environment: string,
  release: string,
  type?: string
) => {
  const bodyPayload: any = { environment, release };
  if (type) bodyPayload.type = type;
  return await fetchData('PATCH', 'schema-sync/schema-sync-approval-v3', {
    body: bodyPayload,
  });
};
